import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/chat/update-icon.svg'
import _imports_1 from '@/components/nav/component/img/message_arrow.svg'
import _imports_2 from '@/assets/location/locationInfo-active.svg'
import _imports_3 from '@/assets/location/locationInfo-default.svg'
import _imports_4 from '@/assets/location/virtual.svg'
import _imports_5 from '../../assets/chat/empty-img-default.svg'
import _imports_6 from './img/up-arrow.svg'
import _imports_7 from './img/down-arrow.svg'
import _imports_8 from './img/dashIns.svg'
import _imports_9 from './img/dashWhatsapp.svg'
import _imports_10 from './img/threeDots.svg'
import _imports_11 from './img/unbinding.svg'
import _imports_12 from './img/iosArrow.svg'
import _imports_13 from './img/message-gou.svg'
import _imports_14 from './img/iphoneModel.svg'
import _imports_15 from '@/assets/ios/online.svg'
import _imports_16 from '@/assets/ios/offline.svg'
import _imports_17 from './img/picture.svg'
import _imports_18 from './img/load.png'


const _withScopeId = n => (_pushScopeId("data-v-652c7a83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "homePage" }
const _hoisted_2 = { class: "btnText" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "updateIcon",
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "btnText" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "updateIcon",
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "btnText" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "updateIcon",
  alt: ""
}, null, -1))
const _hoisted_8 = { class: "btnText" }
const _hoisted_9 = {
  key: 4,
  class: "whatsnew"
}
const _hoisted_10 = { class: "skeleton" }
const _hoisted_11 = { class: "skeletonItemWrapper" }
const _hoisted_12 = { class: "skTop" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "info" }
const _hoisted_15 = { class: "leftIcon" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "content" }
const _hoisted_18 = { class: "text" }
const _hoisted_19 = { class: "newly" }
const _hoisted_20 = {
  key: 0,
  class: "symbol-add"
}
const _hoisted_21 = {
  key: 1,
  class: "symbol-sub"
}
const _hoisted_22 = { class: "total" }
const _hoisted_23 = { class: "showDash" }
const _hoisted_24 = { class: "contact" }
const _hoisted_25 = { class: "theader" }
const _hoisted_26 = {
  key: 0,
  class: "setMinHeight"
}
const _hoisted_27 = { class: "rightInfo" }
const _hoisted_28 = {
  key: 0,
  src: _imports_2,
  alt: "",
  class: "localImg"
}
const _hoisted_29 = {
  key: 1,
  src: _imports_3,
  alt: "",
  class: "localImg"
}
const _hoisted_30 = { class: "itemInfo" }
const _hoisted_31 = { class: "infoDetail" }
const _hoisted_32 = { class: "info" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_37 = { class: "empty-text" }
const _hoisted_38 = {
  key: 0,
  class: "topRightcontent rightcontent"
}
const _hoisted_39 = { class: "average" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "range" }
const _hoisted_42 = { class: "daliy" }
const _hoisted_43 = { class: "float" }
const _hoisted_44 = {
  key: 0,
  src: _imports_6,
  class: "arrow"
}
const _hoisted_45 = {
  key: 1,
  src: _imports_7,
  class: "arrow"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "chartContainer",
  style: {"width":"320px","height":"300px"}
}, null, -1))
const _hoisted_47 = {
  key: 1,
  class: "empty"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_49 = { class: "empty-text" }
const _hoisted_50 = { class: "mostUse" }
const _hoisted_51 = { class: "title" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  key: 1,
  class: "empty"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_55 = { class: "empty-text" }
const _hoisted_56 = {
  key: 0,
  class: "content"
}
const _hoisted_57 = { class: "leftcontent instagram" }
const _hoisted_58 = { class: "insIcon" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "icon"
}, null, -1))
const _hoisted_60 = { class: "title" }
const _hoisted_61 = { class: "theader" }
const _hoisted_62 = { class: "skeleton" }
const _hoisted_63 = { class: "skeletonItemWrapper" }
const _hoisted_64 = { class: "skTop" }
const _hoisted_65 = {
  key: 0,
  class: "setMinHeight"
}
const _hoisted_66 = {
  key: 1,
  class: "empty"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_68 = { class: "empty-text" }
const _hoisted_69 = { class: "rightcontent whatsapp" }
const _hoisted_70 = { class: "appIcon" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  class: "icon"
}, null, -1))
const _hoisted_72 = { class: "title" }
const _hoisted_73 = { class: "theader" }
const _hoisted_74 = { class: "skeleton" }
const _hoisted_75 = { class: "skeletonItemWrapper" }
const _hoisted_76 = { class: "skTop" }
const _hoisted_77 = {
  key: 0,
  class: "setMinHeight"
}
const _hoisted_78 = {
  key: 1,
  class: "empty"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_80 = { class: "empty-text" }
const _hoisted_81 = { class: "message" }
const _hoisted_82 = { class: "bheader" }
const _hoisted_83 = { class: "overflow" }
const _hoisted_84 = { style: {"display":"flex","align-items":"center","justify-items":"space-between","margin-top":"16px","height":"16px","padding":"15px 20px"} }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  class: "unbindImg"
}, null, -1))
const _hoisted_86 = { class: "unbindText" }
const _hoisted_87 = { class: "model" }
const _hoisted_88 = ["src"]
const _hoisted_89 = {
  key: 0,
  class: "iosList"
}
const _hoisted_90 = ["onClick"]
const _hoisted_91 = {
  key: 0,
  class: "checked",
  alt: "",
  src: _imports_13
}
const _hoisted_92 = {
  key: 1,
  class: "checked",
  alt: "",
  src: ""
}
const _hoisted_93 = { class: "info" }
const _hoisted_94 = { class: "topInfo" }
const _hoisted_95 = { class: "bottomInfo" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "model",
  alt: "",
  src: _imports_14
}, null, -1))
const _hoisted_97 = { class: "deviceModel overflow" }
const _hoisted_98 = {
  key: 0,
  class: "dots",
  src: _imports_15,
  alt: ""
}
const _hoisted_99 = {
  key: 1,
  class: "dots",
  src: _imports_16,
  alt: ""
}
const _hoisted_100 = { class: "wrap" }
const _hoisted_101 = { class: "left" }
const _hoisted_102 = { class: "background" }
const _hoisted_103 = ["src"]
const _hoisted_104 = { class: "content" }
const _hoisted_105 = { class: "text" }
const _hoisted_106 = {
  key: 0,
  class: "content"
}
const _hoisted_107 = {
  key: 1,
  class: "content"
}
const _hoisted_108 = {
  key: 2,
  class: "content"
}
const _hoisted_109 = { class: "syncText" }
const _hoisted_110 = {
  class: "bheader",
  style: {"padding-bottom":"20px"}
}
const _hoisted_111 = { style: {"display":"flex","align-items":"center","justify-items":"space-between","margin-top":"16px","height":"16px","padding":"15px 20px"} }
const _hoisted_112 = { style: {"padding-top":"20px"} }
const _hoisted_113 = ["src"]
const _hoisted_114 = {
  key: 0,
  class: "content"
}
const _hoisted_115 = {
  key: 1,
  class: "content"
}
const _hoisted_116 = { class: "renewText" }
const _hoisted_117 = {
  key: 5,
  class: "photos"
}
const _hoisted_118 = { class: "theader" }
const _hoisted_119 = { class: "content" }
const _hoisted_120 = { class: "showPhoto" }
const _hoisted_121 = {
  key: 0,
  class: "itemPhoto"
}
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_17,
  alt: ""
}, null, -1))
const _hoisted_123 = [
  _hoisted_122
]
const _hoisted_124 = { class: "algin" }
const _hoisted_125 = { class: "percent" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_18,
  class: "motionImg"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_messageToast = _resolveComponent("messageToast")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_mapBox = _resolveComponent("mapBox")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_appItem = _resolveComponent("appItem")!
  const _component_numberItem = _resolveComponent("numberItem")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_noticeDialog = _resolveComponent("noticeDialog")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.messageToastType == 1 && !_ctx.isVibe && !_ctx.deviceType)
      ? (_openBlock(), _createBlock(_component_messageToast, {
          key: 0,
          textArr: [
      _ctx.$t('chat.noSyncNotice1'),
      _ctx.$t('chat.noSyncNotice2'),
      _ctx.$t('chat.noSyncNotice3'),
    ]
        }, {
          rightContent: _withCtx(() => [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleUpdateClick && _ctx.handleUpdateClick(...args))),
              class: "rightContent"
            }, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("chat.sync")), 1),
              _hoisted_3
            ])
          ]),
          _: 1
        }, 8, ["textArr"]))
      : _createCommentVNode("", true),
    (_ctx.messageToastType == 2 && !_ctx.autoRenew && !_ctx.isVibe)
      ? (_openBlock(), _createBlock(_component_messageToast, {
          key: 1,
          customStyle: {
      marginBottom: '20px',
      marginTop: '0px',
      marginLeft: '0px',
      marginRight: '0px',
    },
          textArr: [
  _ctx.$t('dashboard.beExpOne'),
  `${_ctx.beExpired} ${_ctx.$t('dashboard.beExpTwo')}`,
  _ctx.$t('dashboard.beExpThree'),
]
        }, {
          rightContent: _withCtx(() => [
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goPay('btn7'))),
              class: "rightContent"
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("dashboard.renew")), 1),
              _hoisted_5
            ])
          ]),
          _: 1
        }, 8, ["textArr"]))
      : _createCommentVNode("", true),
    (_ctx.messageToastType == 3 && !_ctx.isVibe)
      ? (_openBlock(), _createBlock(_component_messageToast, {
          key: 2,
          customStyle: {
      marginBottom: '20px',
      marginTop: '0px',
      marginLeft: '0px',
      marginRight: '0px',
    },
          textArr: [
  _ctx.$t('dashboard.expiredOne'),
  `${_ctx.isExpired} ${_ctx.$t('dashboard.beExpTwo')}`,
  _ctx.$t('dashboard.expiredTwo'),
]
        }, {
          rightContent: _withCtx(() => [
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goPay('btned'))),
              class: "rightContent"
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("dashboard.renew")), 1),
              _hoisted_7
            ])
          ]),
          _: 1
        }, 8, ["textArr"]))
      : _createCommentVNode("", true),
    (_ctx.messageToastType == 4 && !_ctx.isVibe)
      ? (_openBlock(), _createBlock(_component_messageToast, {
          key: 3,
          customStyle: {
      marginBottom: '20px',
      marginTop: '0px',
      marginLeft: '0px',
      marginRight: '0px',
    },
          textArr: [
  _ctx.$t('famikeep210.The current iCloud has expired'), '', ,]
        }, {
          rightContent: _withCtx(() => [
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toLoginIcloud && _ctx.toLoginIcloud(...args))),
              class: "rightContent"
            }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('famikeep210.Go to verification >>')), 1)
            ])
          ]),
          _: 1
        }, 8, ["textArr"]))
      : _createCommentVNode("", true),
    (!_ctx.deviceType)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_el_skeleton, {
                key: 0,
                style: {"--el-skeleton-circle-size":"40px","width":"100%","display":"flex","background":"#fff","justify-content":"space-between"},
                loading: _ctx.loading,
                animated: true,
                count: 5
              }, {
                template: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_el_skeleton_item, {
                      variant: "circle",
                      style: {"margin-right":"12px"}
                    }),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_el_skeleton_item, {
                          variant: "text",
                          style: {"width":"20%"}
                        }),
                        _createVNode(_component_el_skeleton_item, {
                          variant: "text",
                          style: {"width":"10%"}
                        })
                      ]),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"85%"}
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["loading"]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.dashNewData, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "singeItem",
                  key: item.name,
                  onClick: ($event: any) => (_ctx.jumpToMenu(item.path))
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("img", {
                        src: item.src
                      }, null, 8, _hoisted_16)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, [
                        _createVNode(_component_Tooltip, {
                          content: _ctx.$t(`famikeep200.${item.name}`)
                        }, null, 8, ["content"])
                      ]),
                      _createElementVNode("span", _hoisted_19, [
                        _createVNode(_component_Tooltip, {
                          content: _ctx.$t("famikeep200.Compared to yesterday")
                        }, null, 8, ["content"]),
                        _createElementVNode("span", {
                          class: _normalizeClass(item.inc >= 0 ? 'symbol-add' : 'symbol-sub')
                        }, [
                          (item.inc >= 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "+"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_21)),
                          _createTextVNode(" " + _toDisplayString(item.inc), 1)
                        ], 2)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(item.total), 1)
                ], 8, _hoisted_13))
              }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", {
          class: _normalizeClass(["topContent content", [_ctx.deviceType ? 'iosContent' : '', (_ctx.messageToastType == 4 || _ctx.messageToastType == 3 || _ctx.messageToastType == 2 || _ctx.messageToastType == 1) && !_ctx.isVibe && _ctx.deviceType ? 'subHeight' : '']])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["geolocation", _ctx.deviceType ? 'iosGeolocation' : ''])
          }, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", {
                class: _normalizeClass(["title", _ctx.lang == 'ar' ? 'reverse' : ''])
              }, [
                _createVNode(_component_Tooltip, {
                  content: _ctx.$t("famikeep200.Geolocation")
                }, null, 8, ["content"])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["jump", _ctx.lang == 'ar' ? 'reverse' : '']),
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.jumpToLocation && _ctx.jumpToLocation(...args)))
              }, [
                _createVNode(_component_Tooltip, {
                  content: _ctx.$t("famikeep200.All locations")
                }, null, 8, ["content"])
              ], 2)
            ]),
            (_ctx.locationsList && _ctx.locationsList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", {
                    class: "leftMaps",
                    style: _normalizeStyle({ width: _ctx.deviceType ? '987px' : '329px', height: _ctx.deviceType ? '610px' : '308px' })
                  }, [
                    _createVNode(_component_mapBox, {
                      lcoationMap: _ctx.lcoationMap,
                      styleString: { width: _ctx.deviceType ? '987px' : '329px', height: _ctx.deviceType ? '610px' : '308px' },
                      functionPage: 'home'
                    }, null, 8, ["lcoationMap", "styleString"])
                  ], 4),
                  _createElementVNode("div", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationsList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["infoItem pointer", _ctx.deviceType ? 'iosInfoItem' : '']),
                        key: index
                      }, [
                        (index == 0)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_28))
                          : (_openBlock(), _createElementBlock("img", _hoisted_29)),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_Tooltip, {
                                content: item.detail
                              }, null, 8, ["content"])
                            ]),
                            (item.is_virtual)
                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 0,
                                  "popper-class": "custom-tooltip",
                                  content: _ctx.$t('famikeep200.When obtaining this location'),
                                  placement: "bottom-start"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_33
                                  ]),
                                  _: 1
                                }, 8, ["content"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", null, [
                            (_ctx.isVibe)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                                  _createVNode(_component_Tooltip, {
                                    content: _ctx.dateFormatAm(item.date, "YYYY-MM-DD HH:mm:ss")
                                  }, null, 8, ["content"])
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_35, [
                                  _createVNode(_component_Tooltip, {
                                    content: _ctx.dateFormat(item.date, "YYYY-MM-DD HH:mm:ss")
                                  }, null, 8, ["content"])
                                ]))
                          ])
                        ])
                      ], 2))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["empty", _ctx.deviceType ? 'iosEmpty' : ''])
                }, [
                  _hoisted_36,
                  _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("dashboard.blank")), 1)
                ], 2))
          ], 2),
          (!_ctx.deviceType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["title", _ctx.lang == 'ar' ? 'reverse' : ''])
                  }, [
                    _createVNode(_component_Tooltip, {
                      content: _ctx.$t("famikeep200.Weekly average usage time")
                    }, null, 8, ["content"])
                  ], 2),
                  (_ctx.daliyTime)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.daliyTime), 1),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", {
                              class: _normalizeClass(_ctx.useProportion > 0 ? 'changeRed' : 'changeGreen')
                            }, [
                              (_ctx.useProportion > 0)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_44))
                                : (_openBlock(), _createElementBlock("img", _hoisted_45)),
                              _createTextVNode(" " + _toDisplayString(Math.abs(_ctx.useProportion)) + "% ", 1)
                            ], 2),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("famikeep200.Floating comparison with last week")), 1)
                          ])
                        ]),
                        _hoisted_46
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _hoisted_48,
                        _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t("dashboard.blank")), 1)
                      ]))
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_Tooltip, {
                      content: _ctx.$t("famikeep200.Most used applications")
                    }, null, 8, ["content"])
                  ]),
                  (_ctx.appUseList.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appUseList, (item, index) => {
                          return (_openBlock(), _createBlock(_component_appItem, {
                            class: "perc",
                            key: index,
                            item: item
                          }, null, 8, ["item"]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _hoisted_54,
                        _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t("dashboard.blank")), 1)
                      ]))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        (!_ctx.deviceType)
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _createElementVNode("span", _hoisted_60, [
                    _createVNode(_component_Tooltip, {
                      content: _ctx.$t("leftTab.instagram")
                    }, null, 8, ["content"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["title", _ctx.lang == 'ar' ? 'reverse' : ''])
                  }, _toDisplayString(_ctx.$t("dashboard.insContact")), 3),
                  _createElementVNode("div", {
                    class: _normalizeClass(["jump", _ctx.lang == 'ar' ? 'reverse' : '']),
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.jumpToInsContact && _ctx.jumpToInsContact(...args)))
                  }, _toDisplayString(_ctx.$t("dashboard.view")), 3)
                ]),
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_el_skeleton, {
                      key: 0,
                      style: {"--el-skeleton-circle-size":"40px","width":"100%"},
                      loading: _ctx.loading,
                      animated: true,
                      count: 5
                    }, {
                      template: _withCtx(() => [
                        _createElementVNode("div", _hoisted_62, [
                          _createVNode(_component_el_skeleton_item, {
                            variant: "circle",
                            style: {"margin-right":"12px"}
                          }),
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("div", _hoisted_64, [
                              _createVNode(_component_el_skeleton_item, {
                                variant: "text",
                                style: {"width":"20%"}
                              }),
                              _createVNode(_component_el_skeleton_item, {
                                variant: "text",
                                style: {"width":"10%"}
                              })
                            ]),
                            _createVNode(_component_el_skeleton_item, {
                              variant: "text",
                              style: {"width":"20%"}
                            }),
                            _createVNode(_component_el_skeleton_item, {
                              variant: "text",
                              style: {"width":"85%"}
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.ins_session && _ctx.ins_session.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ins_session, (item, index) => {
                              return (_openBlock(), _createBlock(_component_numberItem, {
                                key: index,
                                item: item,
                                host: `instagram`
                              }, null, 8, ["item"]))
                            }), 128))
                          ]))
                        : (!_ctx.loading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                              _hoisted_67,
                              _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t("dashboard.blank")), 1)
                            ]))
                          : _createCommentVNode("", true)
                    ], 64))
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t("leftTab.whatsapp")), 1)
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["title", _ctx.lang == 'ar' ? 'reverse' : ''])
                  }, _toDisplayString(_ctx.$t("dashboard.contact")), 3),
                  _createElementVNode("div", {
                    class: _normalizeClass(["jump", _ctx.lang == 'ar' ? 'reverse' : '']),
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.jumpToContact && _ctx.jumpToContact(...args)))
                  }, _toDisplayString(_ctx.$t("dashboard.view")), 3)
                ]),
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_el_skeleton, {
                      key: 0,
                      style: {"--el-skeleton-circle-size":"40px","width":"100%"},
                      loading: _ctx.loading,
                      animated: true,
                      count: 5
                    }, {
                      template: _withCtx(() => [
                        _createElementVNode("div", _hoisted_74, [
                          _createVNode(_component_el_skeleton_item, {
                            variant: "circle",
                            style: {"margin-right":"12px"}
                          }),
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, [
                              _createVNode(_component_el_skeleton_item, {
                                variant: "text",
                                style: {"width":"20%"}
                              }),
                              _createVNode(_component_el_skeleton_item, {
                                variant: "text",
                                style: {"width":"10%"}
                              })
                            ]),
                            _createVNode(_component_el_skeleton_item, {
                              variant: "text",
                              style: {"width":"20%"}
                            }),
                            _createVNode(_component_el_skeleton_item, {
                              variant: "text",
                              style: {"width":"85%"}
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.active_session && _ctx.active_session.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.active_session, (item, index) => {
                              return (_openBlock(), _createBlock(_component_numberItem, {
                                key: index,
                                item: item
                              }, null, 8, ["item"]))
                            }), 128))
                          ]))
                        : (!_ctx.loading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                              _hoisted_79,
                              _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.$t("dashboard.blank")), 1)
                            ]))
                          : _createCommentVNode("", true)
                    ], 64))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_81, [
        _createElementVNode("div", {
          class: _normalizeClass(["device account", _ctx.lang == 'ar' ? 'reverse' : '']),
          style: {"padding":"20px 0 0 0"}
        }, [
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("span", _hoisted_83, [
              _createVNode(_component_Tooltip, {
                content: _ctx.$t("dashboard.target")
              }, null, 8, ["content"])
            ]),
            _withDirectives(_createElementVNode("img", {
              src: _imports_10,
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toUnbind && _ctx.toUnbind(...args))),
              style: {"cursor":"pointer"}
            }, null, 512), [
              [_directive_click_outside, _ctx.handleClickOutside]
            ])
          ]),
          _createVNode(_component_el_skeleton, {
            style: {"width":"100%"},
            loading: _ctx.loading,
            animated: "",
            count: 8
          }, {
            template: _withCtx(() => [
              _createElementVNode("div", _hoisted_84, [
                _createVNode(_component_el_skeleton_item, {
                  variant: "text",
                  style: {"width":"15%"}
                }),
                _createVNode(_component_el_skeleton_item, {
                  variant: "text",
                  style: {"margin-left":"16px","width":"80%"}
                })
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.isVibe ? 'demoStyle' : '')
              }, [
                (_ctx.showUnbind)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["unbinding", _ctx.lang == 'ar' ? 'changePlace' : '']),
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.unbindDevice && _ctx.unbindDevice(...args))),
                      id: "showDiv"
                    }, [
                      _hoisted_85,
                      _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.$t("pop.unbindTitle")), 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("img", {
                  src: _ctx.deviceType ? _ctx.iphone : _ctx.Launcher,
                  alt: ""
                }, null, 8, _hoisted_88),
                _createElementVNode("div", {
                  class: _normalizeClass(["dexText", _ctx.lang == 'ar' ? 'changePadding' : ''])
                }, [
                  _withDirectives((_openBlock(), _createElementBlock("span", {
                    class: _normalizeClass(["deviceName overflow", _ctx.deviceType ? 'iosDeviceName' : '']),
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.changeDevice && _ctx.changeDevice(...args)))
                  }, [
                    _createVNode(_component_Tooltip, { content: _ctx.currentDevice }, null, 8, ["content"]),
                    (_ctx.deviceType)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: _normalizeClass(["arrow", _ctx.showIosList ? 'toRotate' : 'backRotate']),
                          src: _imports_12,
                          alt: ""
                        }, null, 2))
                      : _createCommentVNode("", true)
                  ], 2)), [
                    [_directive_click_outside, _ctx.handleClickIosList]
                  ]),
                  (_ctx.showIosList)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iosList, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "singleItem",
                            key: index,
                            onClick: ($event: any) => (_ctx.changeDeviceModel(index))
                          }, [
                            (item.id == _ctx.currentDeviceId)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_91))
                              : (_openBlock(), _createElementBlock("img", _hoisted_92)),
                            _createElementVNode("div", _hoisted_93, [
                              _createElementVNode("div", _hoisted_94, [
                                _createVNode(_component_Tooltip, {
                                  content: item.name
                                }, null, 8, ["content"])
                              ]),
                              _createElementVNode("div", _hoisted_95, [
                                _hoisted_96,
                                _createVNode(_component_Tooltip, {
                                  content: item.model
                                }, null, 8, ["content"])
                              ])
                            ])
                          ], 8, _hoisted_90))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_97, [
                    _createVNode(_component_Tooltip, { content: _ctx.currentDeviceModel }, null, 8, ["content"])
                  ]),
                  (_ctx.deviceType)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass(["deviceActive overflow", _ctx.isActive ? 'activeColor' : 'deColor'])
                      }, [
                        (_ctx.isActive)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_98))
                          : (_openBlock(), _createElementBlock("img", _hoisted_99)),
                        (_ctx.isActive)
                          ? (_openBlock(), _createBlock(_component_Tooltip, {
                              key: 2,
                              content: _ctx.$t('famikeep210.Online')
                            }, null, 8, ["content"]))
                          : (_openBlock(), _createBlock(_component_Tooltip, {
                              key: 3,
                              content: _ctx.$t('famikeep210.Offline')
                            }, null, 8, ["content"]))
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.showRebound)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        class: "reboundText",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toRebound && _ctx.toRebound(...args)))
                      }, [
                        _createVNode(_component_Tooltip, {
                          content: _ctx.$t("pop.changeBound")
                        }, null, 8, ["content"])
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_100, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceType ? _ctx.iosDevice : _ctx.targetDevice, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item,
                    class: "tgDevice"
                  }, [
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("img", {
                          src: item.src
                        }, null, 8, _hoisted_103)
                      ]),
                      _createElementVNode("div", _hoisted_104, [
                        _createElementVNode("span", _hoisted_105, [
                          _createVNode(_component_Tooltip, {
                            content: item.text
                          }, null, 8, ["content"])
                        ]),
                        (item.data)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_106, _toDisplayString(item.content
                        ? _ctx.dateFormat(item.content, "YYYY-MM-DD HH:mm")
                        : ""), 1))
                          : (item.battery)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_107, _toDisplayString(item.content ? item.content + "%" : "--"), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_108, _toDisplayString(item.content ? item.content : "--"), 1))
                      ])
                    ]),
                    (item.data)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "syncBtn",
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleUpdateClick && _ctx.handleUpdateClick(...args)))
                        }, [
                          _createElementVNode("img", {
                            src: _imports_0,
                            class: _normalizeClass(["updateIcon", _ctx.syncLoading ? 'loading' : '']),
                            alt: ""
                          }, null, 2),
                          _createElementVNode("span", _hoisted_109, [
                            _createVNode(_component_Tooltip, {
                              content: _ctx.$t("chat.sync")
                            }, null, 8, ["content"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["account", _ctx.lang == 'ar' ? 'reverse' : '']),
          id: "account",
          style: {"padding":"20px 0","margin-top":"20px"}
        }, [
          _createElementVNode("div", _hoisted_110, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("dashboard.account")), 1)
          ]),
          _createVNode(_component_el_skeleton, {
            style: {"width":"80%"},
            loading: _ctx.loading,
            animated: "",
            count: 4
          }, {
            template: _withCtx(() => [
              _createElementVNode("div", _hoisted_111, [
                _createVNode(_component_el_skeleton_item, {
                  variant: "text",
                  style: {"width":"30%"}
                }),
                _createVNode(_component_el_skeleton_item, {
                  variant: "text",
                  style: {"margin-left":"16px"}
                })
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_112, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.account, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["one", item.singular ? 'zebra' : '']),
                    key: index
                  }, [
                    _createElementVNode("img", {
                      src: item.src,
                      style: {"padding-right":"10px"}
                    }, null, 8, _hoisted_113),
                    _createElementVNode("span", {
                      class: _normalizeClass(["text", index == 2 ? 'boundedDevice' : ''])
                    }, [
                      _createTextVNode(_toDisplayString(item.text) + " ", 1),
                      (item.data)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_114, _toDisplayString(item.content
                      ? _ctx.dateFormat(item.content, "YYYY-MM-DD HH:mm")
                      : ""), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_115, _toDisplayString(item.content ? item.content : "--"), 1))
                    ], 2)
                  ], 2))
                }), 128)),
                (!_ctx.autoRenew)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "renew",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goPay('btn')))
                    }, [
                      _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.$t("dashboard.renew")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ], 2)
      ])
    ]),
    (_ctx.deviceType)
      ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
          _createElementVNode("div", _hoisted_118, [
            _createElementVNode("div", {
              class: _normalizeClass(["title", _ctx.lang == 'ar' ? 'reverse' : ''])
            }, [
              _createVNode(_component_Tooltip, {
                content: _ctx.$t("dashboard.target")
              }, null, 8, ["content"])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["jump", _ctx.lang == 'ar' ? 'reverse' : '']),
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.jumpToPhoto && _ctx.jumpToPhoto(...args)))
            }, [
              _createVNode(_component_Tooltip, {
                content: _ctx.$t("dashboard.view")
              }, null, 8, ["content"])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_119, [
            _createElementVNode("div", _hoisted_120, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photoListArray, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "photoItem",
                  key: index
                }, [
                  _createVNode(_component_el_image, {
                    class: "itemPhoto",
                    src: item.thumb_url ? item.thumb_url : item.origin_url,
                    fit: "contain"
                  }, null, 8, ["src"])
                ]))
              }), 128))
            ]),
            (!_ctx.photoListArray.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                    return _createElementVNode("div", {
                      class: "emptyPhoto",
                      key: index
                    }, _hoisted_123)
                  }), 64))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showUnbindDialog)
      ? (_openBlock(), _createBlock(_component_noticeDialog, {
          key: 6,
          visible: _ctx.showUnbindDialog,
          user: true,
          title: _ctx.$t('pop.unbindTitle'),
          width: 480,
          info: `${_ctx.$t('pop.unbindText1')} ${_ctx.deviceType ? _ctx.currentAppleId : _ctx.currentDevice} ${_ctx.$t(
      'pop.unbindText2'
    )}`,
          onConfirm: _ctx.closeDialog,
          onCancle: _ctx.confirmUnbind,
          onUnbindCancle: _ctx.closeDialog,
          Cancel: _ctx.$t('pop.yes'),
          Okay: _ctx.$t('pop.no')
        }, null, 8, ["visible", "title", "info", "onConfirm", "onCancle", "onUnbindCancle", "Cancel", "Okay"]))
      : _createCommentVNode("", true),
    (_ctx.showReboundDialog)
      ? (_openBlock(), _createBlock(_component_noticeDialog, {
          key: 7,
          visible: _ctx.showReboundDialog,
          title: _ctx.$t('pop.changeBound'),
          width: 480,
          info: `${_ctx.$t('pop.reboundText1')} ${_ctx.currentDevice} ${_ctx.$t(
      'pop.reboundText2'
    )}${_ctx.dateFormat(_ctx.subscripts, 'YYYY-MM-DD')}${_ctx.$t('pop.reboundText3')}`,
          onConfirm: _ctx.confirmRebind,
          onCancle: _ctx.closeReboundDialog,
          Cancel: _ctx.$t('pop.no'),
          Okay: _ctx.$t('pop.yes')
        }, null, 8, ["visible", "title", "info", "onConfirm", "onCancle", "Cancel", "Okay"]))
      : _createCommentVNode("", true),
    (_ctx.showRebounding)
      ? (_openBlock(), _createBlock(_component_noticeDialog, {
          key: 8,
          visible: _ctx.showRebounding,
          title: _ctx.$t('pop.rebounding'),
          width: 480,
          showclose: false,
          showBtn: false
        }, {
          img: _withCtx(() => [
            _createElementVNode("div", _hoisted_124, [
              _createElementVNode("div", _hoisted_125, _toDisplayString(_ctx.percent) + "%", 1),
              _hoisted_126
            ])
          ]),
          _: 1
        }, 8, ["visible", "title"]))
      : _createCommentVNode("", true),
    (_ctx.showReboundFailed)
      ? (_openBlock(), _createBlock(_component_noticeDialog, {
          key: 9,
          visible: _ctx.showReboundFailed,
          title: _ctx.$t('pop.changeBound'),
          width: 480,
          info: `${_ctx.$t('pop.reboundFail1')} ${_ctx.currentDevice} ${_ctx.$t(
      'pop.reboundFail2'
    )}`,
          onConfirm: _ctx.confirmRebind,
          onCancle: _ctx.closeReboundFailed,
          Cancel: _ctx.$t('pop.cancel'),
          Okay: _ctx.$t('pop.tryAgain')
        }, null, 8, ["visible", "title", "info", "onConfirm", "onCancle", "Cancel", "Okay"]))
      : _createCommentVNode("", true),
    (_ctx.showNoLocation)
      ? (_openBlock(), _createBlock(_component_noticeDialog, {
          key: 10,
          visible: _ctx.showNoLocation,
          title: _ctx.$t('pop.changeBound'),
          width: 480,
          info: _ctx.$t('pop.noRebound'),
          onConfirm: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goPay(_ctx.pop))),
          onCancle: _ctx.closeNoLocation,
          Okay: _ctx.$t('pop.goPay'),
          Cancel: _ctx.$t('pop.cancel')
        }, null, 8, ["visible", "title", "info", "onCancle", "Okay", "Cancel"]))
      : _createCommentVNode("", true)
  ]))
}